import { atom } from 'recoil';
import type { ShoppingBasketOverlayInfo } from '../types/onsaTypes';

export const shoppingBasketOverlayAtom = atom<ShoppingBasketOverlayInfo>({
    key: 'shoppingBasketOverlayInfo',
    default: {
        isOverlayOpen: false,
        isButtonDisplayed: false
    }
});
